import { useCallback } from 'react';
import { supplierEmployeeService } from '@api/services/services';

interface EmployeeData {
  name?: string;
  lastName?: string;
  email?: string;
  phone?: string;
}

export const useCreateSupplierEmployee = (navigate: (url: string) => void) => {
  return useCallback(
    async (supplier: string, id: string, employeeData: EmployeeData) => {
      const data = await supplierEmployeeService.getById(id);

      if (data.data.supplier && !data.data.oneTime) {
        alert('This user is already a supplier employee.');
      } else {
        const url = `/supplier/${supplier}/employee-from-visitor/${id}`;

        const params = new URLSearchParams();
        employeeData.name && params.append('name', employeeData.name);
        employeeData.lastName && params.append('lastName', employeeData.lastName);
        employeeData.email && params.append('email', employeeData.email);
        employeeData.phone && params.append('phone', employeeData.phone);
        navigate(url + '?' + params.toString());
      }
    },
    [navigate]
  );
};
